/**
 * Zoom bands for crop-monitoring bid map APIs (aligned with {@link RegionManagerService} level-3 minZoom).
 */

export const BID_MAP_ZOOM_CLUSTER_MIN = 9;
export const BID_MAP_ZOOM_AGGREGATE_MAX = 8;
export const BID_MAP_ZOOM_DETAIL_MIN = 14;
export const BID_MAP_ZOOM_CLUSTER_BAND_MAX = 13;
export const BID_MAP_CLUSTER_CIRCLE_CLICK_ZOOM = 14;

export type BidMapZoomBand = 'agg' | 'cluster' | 'detail';

export function bidMapZoomBand(z: number): BidMapZoomBand {
  if (z < BID_MAP_ZOOM_CLUSTER_MIN) {
    return 'agg';
  }
  if (z < BID_MAP_ZOOM_DETAIL_MIN) {
    return 'cluster';
  }
  return 'detail';
}
